<template>
    <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-xl-6">
              <h1 class="card-title">Plan de Prévention Evolutif - Status page Version {{ version }}</h1>
        </div>
      </div>

      <div class="row" style="flex-direction: column;">
        <h2>Nb sociétés :   {{ companyCount }}</h2>
        <h2>Nb opérations : {{ operationCount }}</h2>
        <h2>Memoire occupée: {{ Math.floor( (memory.used * 100) / memory.total) }}%</h2>
        <h2>Disque occupé: {{ Math.floor( (disk.used * 100) / disk.total) }}%</h2>
      </div>
    </div>
    </div>    
</template>
<style scoped>

</style>
<script>
import Card from "../components/Cards/Card.vue";
import swal from "sweetalert";
import common from './common/pages.js'

export default {
  components: {
    Card,
  },
  data() {
    return  {
      version : '?',
      companyCount : 0,
      operationCount : 0,
      disk : {},
      memory : {},
    }
  },
    methods: {
      ...common.methods,

    },
    async mounted() { 
      let res = await this.$http.get('/status')
      this.version = res.data.version
      this.disk = res.data.disk
      this.memory = res.data.memory
      this.companyCount = res.data.companyCount
      this.operationCount = res.data.operationCount
    }
}
</script>
